export enum OrganType {
  Nest = "ken",
  County = "mahoz",
  Circle = "kehila",
}



// WEBPACK FOOTER //
// ./src/app/_models/organ-type.ts